import store from "@/store/index";
import nativeHandlerService from "../../nativeHandler";

export const goToBook = (masterBook, router) => {
  // 券種まとめがある場合(is_set:true)、queryにmaster_book_set_idを持たせる
  try {
    if (process.env.NODE_ENV === "local") {
      var query = masterBook.is_set
        ? {
          language: store.getters["common/lang"],
          master_book_set_id: masterBook.master_book_set_id,
        }
        : { language: store.getters["common/lang"] };

      router.push({
        name: "MasterBook",
        params: { id: masterBook.id },
        query: query,
      });
    } else {
      var _query = masterBook.is_set
        ? `?master_book_set_id=${masterBook.master_book_set_id}`
        : "";

      nativeHandlerService.openTicket(
        `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}ticket-store/ticketing/master-book/${masterBook.id}${_query}`,
        "STR"
      );
    }
  } catch (e) {
    console.log("Error in goToBook ", e);
  }
};